<script>
import urlJoin from 'url-join'
import CitiesServices from '@/services/cities'
import CircleSpinner from '@/components/CircleSpinner'
import Button from '@/components/Button'
import DeviceUtils from '@/utils/deviceUtils'
import Config from '~/config/index'

export default
{
    name: 'application',

    created ()
    {
        const appBundleId = this.$route.params.appBundleId
        console.log('Fetching information for app', appBundleId)

        CitiesServices.getCityManifest(appBundleId).then(manifest =>
        {
            this.cityManifest = manifest

            const action = this.$route.query.action
            console.log('Executing action', action)

            if (action == 'download') this.openStore(true)
        })
    },

    render () 
    {
        return (
            <div id='application-view'>
            <div class='loading' v-show={!this.cityManifest}>
                <div class='title'>Chargement de l'application…</div>
                <circle-spinner />
            </div>
            {
                this.cityManifest &&
                <div class='loaded'>
                    <div class='app-header'>
                        <div class='icon'>
                            <img src={urlJoin(Config.distCdnUrl, 'find', 'cities', this.cityManifest.id.toString(), 'city-icon')} />
                        </div>
                        <div class='name'>{this.cityManifest.appName}</div>
                    </div>
                    <Button text="Télécharger l'application" on-click={() => this.openStore()} />
                </div>
            }
            </div>
        )
    },

    data () 
    {
        return {
            cityManifest: null
        }
    },

    mounted ()
    {
    },

    methods:
    {
        openStore (replace)
        {
            const sanitazedName = this.cityManifest.appName.replace(/[\?!#'"]+/gm, '').toLowerCase().replace(/ /gm, '-')
            const appStoreUrl = urlJoin('https://apps.apple.com/fr/app', sanitazedName, 'id' + this.cityManifest.appAppleId, '?platform=iphone')
            const playStoreUrl = urlJoin('https://play.google.com/store/apps/details', '?id=' + this.cityManifest.appBundleId)
            const redirectUrl = DeviceUtils.getMobileOperatingSystem() == 'Android' ? playStoreUrl : appStoreUrl

            console.log('App store url:', appStoreUrl, 'play store url', playStoreUrl, 'redirect =>', redirectUrl)

            if (replace)
            {
                document.location.replace(redirectUrl)
            }
            else
            {
                window.open(redirectUrl, '_blank')
            }
        }
    },

    components:
    {
        CircleSpinner,
        Button
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#application-view
{
    min-height: 100vh;
    min-width: 100vw;
    display: flex;
    justify-content: center;
    background: rgb(119,111,249);
    background: linear-gradient(160deg, var(--theme-accent-color) 46%, rgba(171,0,255,1) 100%);
    color: #ffffffc0;

    ::selection
    {
        background: #ffffff50;
    }

    b
    {
        color: white;
    } 

    .loading
    {
        display: inherit;
        justify-content: inherit;
        width: inherit;
        height: inherit;
    }
    
    .circle-spinner
    {
        fill: white;
        width: 50vw;
        position: absolute;
        margin-top: 20vh;

        .OnLargeMobile({ margin-top: 30vh; });
        .OnDesktop({
            margin-top: 30vh;
            width: 10vw;
        });
    }

    .title
    {
        position: absolute;
        font-weight: bolder;
        font-size: 40px;
        text-align: center;
        top: 60vh;
    }

    .loaded
    {
        margin-top: 20vh;
    }

    .button
    {
        width: 100%;
        width: -webkit-fill-available;
    }

    .app-header
    {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 40px;

        .OnDesktop({ flex-direction: row; });
        
        .icon
        {
            width: 200px;

            img
            {
                width: 100%;
                height: 100%;
            }
        }

        .name
        {
            font-weight: bolder;
            font-size: 30px;
            color: white;

            .OnDesktop({
                max-width: 300px;
                margin-left: 20px;
                font-size: 40px;
            });
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Application.vue